export default "__VITE_PUBLIC_ASSET__d90d385f__"